const resolveHtmlArticleSectionId = (articleType) => {
  if (articleType === 'workshop') {
    return 'workshopy';
  } else {
    return 'program'
  }
}

export default resolveHtmlArticleSectionId
